import { types } from 'mobx-state-tree'
import { BaseAppointmentStore } from '@shared/data-access'
import { Model, MODEL_NAME } from './model'

export const Store = BaseAppointmentStore.named(`${MODEL_NAME}Store`).props({
  map: types.map(Model),
})

export default Store
